import $ from 'jquery';	
import {formatMoney} from '@shopify/theme-currency';



loadAllProducts();

rdApp.handelize = function (value) {
	return value.toLowerCase().replace(/\s/g, '-').replace(/[^a-zA-Z0-9-]/g, '').replace(/-+/g, '-');
}
rdApp.selectCallback = function(variant, selector){
		if(variant && variant.available){
				$('#add-to-cart').removeClass('disabled').removeAttr('disabled');
				// Enable the Add to Cart button
				$('.single-price').html('<strong>'+formatMoney(variant.price, theme.moneyFormat)+'</strong>');
				// Show price of the currently selected variant
		}
		else{
				$('#add-to-cart').addClass('disabled').attr('disabled', 'disabled');
				// Disable the Add to Cart button
				$('.single-price').text("Sold Out!");
				// Swap price with a 'Sold Out' message
		}
}


rdApp.init = function() {
	for (var pid in rdApp.products) {
		var product = rdApp.products[pid];
		rdApp.products[pid].productOptions = {};
		rdApp.products[pid].optionRelations = {};
		rdApp.products[pid].optionRelationsDouble = {};

		$.each(product.options, function(index, option) {
			rdApp.products[pid].productOptions[option] = [];
			$.each(product.variants, function(i, variant) {
				rdApp.products[pid].optionRelations[variant.options[index]] = rdApp.products[pid].optionRelations[variant.options[index]] || [];
				for (var k=0; k<variant.options.length; k++) {
					var relName = [];
					for(var r=0; r<3; r++) {
						if (r==k) continue;
						if (!variant.options[r]) continue;
						relName.push(variant.options[r]);
					}
					relName = relName.join('-');
					rdApp.products[pid].optionRelationsDouble[relName] = rdApp.products[pid].optionRelationsDouble[relName] || [];
					if (rdApp.products[pid].optionRelationsDouble[relName].indexOf(variant.options[k]) == -1) {
						rdApp.products[pid].optionRelationsDouble[relName].push(variant.options[k]);
					}
					if (k==index) continue;
					if (!variant.available) continue;
					if (rdApp.products[pid].optionRelations[variant.options[index]].indexOf(variant.options[k]) == -1) {
						rdApp.products[pid].optionRelations[variant.options[index]].push(variant.options[k]);
					}
					
				}

				if ($.inArray(variant.options[index], rdApp.products[pid].productOptions[option]) == -1) {
					rdApp.products[pid].productOptions[option].push(variant.options[index]);
				}
			});
		});
	}

	$('#products-list').on('click', '.btn-group-toggle label', function(e) {
		e.stopPropagation();
		var product_id = $(this).parents('.item').data('id');
		//e.preventDefault();
		rdApp.clickedOption = null;
		// rdApp.clickedProduct = product_id;
		if ($(this).hasClass('disabled')) return false;
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
		} else {
			$(this).addClass('active').siblings().removeClass('active');
			rdApp.clickedOption = {option: $(this).parents('.options-wrapper').data('option'), value: $(this).text()};
		}
		rdApp.checkAvailableOptions(product_id);
		rdApp.checkAllSelected(product_id);

		$(this).parents('.item').find('.sw-btn-next').click();
		setTimeout(function() { $('.options-wrapper').show(); }, 100);
	});
	$('#products-list').on('click', '.btn-group-toggle input', function(e) {
		e.preventDefault();
		return false;
	});

	$( "#products-list" ).on( "click", ".toggle-atc", function() {
		var product_id = $(this).parents('.item').data('id');
		$(this).parents('.item').find('.cta').toggleClass('d-none');
		rdApp.checkAllSelected(product_id);
		return false;
	});


	/*$('.selector-wrapper select option').each(function() {
		$(this).parents('.selector-wrapper').append('<span data-value="'+$(this).val()+'" class="'+($(this).is(':selected') ? 'active' : '')+'">'+$(this).text()+'</span>');
	});*/
}

rdApp.checkAvailableOptions = function(product_id) {
	$('.item-'+product_id+' .options-wrapper label').removeClass('disabled');
	var toDisable = $('.item-'+product_id+' .options-wrapper label').not('.active').filter(function() {
		var option = $(this).parents('.options-wrapper').data('option');
		//console.log('Option wrapper: '+option);
		var selector = [];
		$('.item-'+product_id+' .options-wrapper:not(.option-'+option+') label.active').each(function() {
			selector.push($(this).data('option'));
		});
		//console.log(selector);
		switch (selector.length) {
			case 2: 
			selector = selector.join('-');
				if (! rdApp.products[product_id].optionRelationsDouble[selector]) return true;
				//console.log('checking 2: '+$(this).data('option'));
				//console.log('selector: '+selector);
				//console.log((rdApp.products[product_id].optionRelationsDouble[selector].indexOf($(this).data('option').toString()) == -1));
				return (rdApp.products[product_id].optionRelationsDouble[selector].indexOf($(this).data('option').toString()) == -1);
				break;
			case 1:
				selector = selector[0];
				if (! rdApp.products[product_id].optionRelations[selector]) return true;
				//console.log('checking 1: '+$(this).data('option'));
				//console.log('selector: '+selector);
				//console.log(rdApp.products[product_id].optionRelations[selector].indexOf($(this).data('option').toString()) == -1);
				//console.log('rdApp.products['+product_id+'].optionRelations['+selector+'].indexOf('+$(this).data('option')+')');
				return (rdApp.products[product_id].optionRelations[selector].indexOf($(this).data('option').toString()) == -1);
				break;
			default: 
				//console.log('Unexpected selector length: '+selector.length);
				return false;
		}
	});
	//console.log('We need to disable:');
	//console.log(toDisable);
	toDisable.addClass('disabled');
}

rdApp.checkAllSelected = function(product_id) {
	var exit = false;
	rdApp.selected = [];
	$('.item-'+product_id+' .options-wrapper').each(function() {
		if (exit) return;
		var selected = $(this).find('label.active');
		rdApp.selected.push(selected);
		if (selected.length == 0) {
			rdApp.updateButtonText(product_id, $(this).find('.option-wrapper-title').text(), true);
			exit = true;
			return;
		}
	});
	if (exit) return;
	//rdApp.updateButtonText(product_id, 'Add to cart', false);
	var variant = rdApp.findVariant(product_id);
	rdApp.selectionCallback(product_id, variant);
	//console.log(variant);
}

rdApp.findVariant = function(product_id) {
	for (var i=0; i<rdApp.products[product_id].variants.length; i++) {
		var variant = rdApp.products[product_id].variants[i];
		var selected = true;
		for (var k=0; k<variant.options.length; k++) {
			//console.log('Variant option: '+variant.options[k]);
			//console.log('Selected option: '+$('.options-wrapper:eq('+k+') li.selected').text());
			if (variant.options[k] != $('.item-'+product_id+' .options-wrapper:eq('+k+') label.active').data('option')) {
				selected = false;
			}
		}
		if (selected) {
			//console.log('selected varaiant: '+variant.id);
			return variant;
		}
	}
	//console.log('variant not found');
}

rdApp.updateButtonText = function(product_id, text, disabled) {
	$('.item-'+product_id+' button[type=submit] span').text(text);
	if (disabled) {
		$('.item-'+product_id+' button[type=submit]').addClass('disabled btn-link');
		$('.item-'+product_id+' button[type=submit]').removeClass('btn-primary');
		$('.item-'+product_id+' button[type=submit] i').addClass('d-none');
	} else {
		$('.item-'+product_id+' button[type=submit]').removeClass('disabled btn-link');
		$('.item-'+product_id+' button[type=submit]').addClass('btn-primary');
		$('.item-'+product_id+' button[type=submit] i').removeClass('d-none');
	}
	
}

rdApp.selectionCallback = function(product_id, variant) {
	$('.item-'+product_id+' input[name=id]').val(variant.id);
	//history.replaceState( {} , '', '?variant='+variant.id );
	if (variant.available) {
		$('.price').text(formatMoney(variant.price, theme.moneyFormat));
		rdApp.updateButtonText(product_id, 'Add to cart', false);
	} else {
		rdApp.updateButtonText(product_id, 'Out of stock', true);
	}
}

//console.log('init');
//setTimeout(function() {
//	rdApp.init();
//}, 5000);



//filters

rdApp.debug = false;
rdApp.run.push('initFilters');
rdApp.filterCollection = function() {
	if (rdApp.debug) console.log('filtering');
	if ($('#filters input:checked').length == 0) {
		$('#products-list .item').show();
		return;
	}
	rdApp.filters = [];
	$('.filter-wrap').each(function() {
		rdApp.filters.push($(this).find('input[type=checkbox]:checked').map(function() { return $(this).data('tag').toString(); }).get());
	});
	$('#products-list .item').hide().filter(function() {
		var item_f = $(this).data('filters').trim().split(' ');
		if (rdApp.debug) console.log('Filters: '+$(this).data('filters'));
		//var show = true;
		for (var f=0; f<rdApp.filters.length; f++) {
			if (rdApp.filters[f].length == 0) {
				if (rdApp.debug) console.log('nothing to filter by '+f);
				continue;
			}
			var ff = false;
			for (var i=0; i<rdApp.filters[f].length; i++) {
				if (item_f.indexOf(rdApp.filters[f][i]) >= 0) {
					ff = true;
				}
			}
			if (!ff) {
				if (rdApp.debug) console.log('EXCLUDE: nothing found for '+rdApp.filters[f].join(' '));
				return false;
			}
		}
		return true;
	}).show();
}

rdApp.preselectFilters = function() {
	var tags = location.hash;
	if (tags == '') return;
	tags = tags.replace('#', '').split('+');
	$.each(tags, function(i, t) {
		$('.filter span[data-tag="'+t+'"]').addClass('active');
	});
	rdApp.filterCollection();

}

rdApp.buildURL = function() {
	var url = [];
	$('.filter span.active').each(function () {
		url.push($(this).data('tag'));
	});
	if (url.length > 0) {
		window.location.hash = '#'+url.join('+');
	} else {
		window.location.hash = '';
	}
	

}

rdApp.initFilters = function () {
	//console.log('init filters');
	var filters = {};
	const regex = /collections\/[^\/]+\/([^\?]+)/g;
	var m = regex.exec(location.href);
	if (m) {
		if (m.length > 1) {
			var urlFilters = m[1].split('+');
		} else {
			urlFilters = [];
		}
	} else {
		urlFilters = [];
	}

	$('#filters span[data-filter]').each(function() {
		if (filters[$(this).data('filter')] == undefined) {
			filters[$(this).data('filter')] = [];
		}
		filters[$(this).data('filter')].push({
			out: $(this).data('value'),
			handle: $(this).data('value-h'),
		});
		$(this).remove();
	});

	for (var filter in filters) {
		var box = $('<div class="filter" data-filter="'+filter+'"><h5 class="filter-title">Filter by '+filter+'</h5></div>');
		var values = filters[filter];
		for (var i=0; i<values.length; i++) {
			var handle = 'filter_'+filter+'_'+values[i].handle;
			var active = urlFilters.indexOf(handle) >= 0 ? true : false;
			box.append('<span data-tag="'+handle+'" '+(active ? 'class="active"' : '')+'>'+values[i].out+'</span>');
		}
		box.appendTo($('#filters'));
	}

	/*$('#filters span[data-tag]').click(function (e) {
		e.preventDefault();
		$(this).toggleClass('active');
		rdApp.filterCollection();
	});*/

	$('#filters input[type=checkbox]').click(function(e) {
		rdApp.filterCollection();
	})

	rdApp.preselectFilters();
}



